import React, { useEffect, useState } from "react";
import api from "@/lib/api";

export default function News() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/announcements").then(r => setItems(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="news-page">
      <section className="bg-scu-obsidian text-white">
        <div className="mx-auto max-w-[1400px] px-4 lg:px-8 py-20">
          <div className="text-xs uppercase tracking-[0.35em] text-scu-electric">News & Updates</div>
          <h1 className="mt-3 font-bebas text-6xl md:text-8xl tracking-wider">Announcements</h1>
        </div>
        <div className="stripe-divider" />
      </section>

      <section className="mx-auto max-w-[1400px] px-4 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 gap-6">
          {items.length === 0 && <div className="text-scu-smoke">No announcements yet.</div>}
          {items.map((a) => (
            <article key={a.id} data-testid={`news-${a.id}`} className={`border rounded-md p-6 bg-white ${a.pinned ? 'border-scu-purple' : 'border-scu-smoke/15'}`}>
              <div className="flex items-center gap-2">
                <span className="text-[10px] uppercase tracking-widest font-bold text-scu-purple bg-scu-purple/10 px-2 py-1 rounded">{a.category}</span>
                {a.pinned && <span className="text-[10px] uppercase tracking-widest font-bold text-white bg-scu-obsidian px-2 py-1 rounded">Pinned</span>}
              </div>
              <h3 className="mt-3 font-bebas text-3xl tracking-wide text-scu-obsidian">{a.title}</h3>
              <p className="mt-2 text-scu-smoke leading-relaxed">{a.body}</p>
              <div className="mt-4 text-xs text-scu-smoke/70">{a.author} · {new Date(a.created_at).toLocaleDateString()}</div>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}
